<template>
	<div>
		<b-form-file
			:value="value"
			:accept="accept"
			:multiple="multiple"
			:placeholder="placeholder"
			:drop-placeholder="dropPlaceholder"
			:state="state"
			:disabled="disabled || working"
			:browse-text="browseText"
			@input="onFilePicked"
			@change="$emit('change', $event)"
		></b-form-file>

		<!--
			Sur Android, capture="environment" ouvre l'appareil photo mais retire l'accès à la galerie
			et aux fichiers : il faut donc un second input, et non un attribut sur le premier.
		-->
		<template v-if="showCamera">
			<input
				class="d-none"
				ref="camera-input"
				type="file"
				accept="image/*"
				capture="environment"
				:multiple="multiple"
				@change="onCameraPicked"
			/>

			<b-button
				class="mt-2"
				variant="outline-primary"
				size="sm"
				:disabled="disabled || working"
				@click="openCamera"
			>
				<font-awesome-icon v-if="working" :icon="['fas', 'spinner']" pulse />
				<font-awesome-icon v-else :icon="['fal', 'camera']" />
				{{ $t('fichier.prendre_photo') }}
			</b-button>
		</template>
	</div>
</template>

<script type="text/javascript">
	import Common from '@/assets/js/common.js'

	export default {
		name: 'MediaInput',
		props: {
			value: {},
			accept: {
				type: String,
				default: () => ''
			},
			multiple: {
				type: Boolean,
				default: () => false
			},
			placeholder: {
				type: String,
				default: () => ''
			},
			dropPlaceholder: {
				type: String,
				default: () => ''
			},
			state: {
				default: () => null
			},
			disabled: {
				type: Boolean,
				default: () => false
			},
			browseText: {
				type: String,
				default: () => ''
			}
		},
		data () {
			return {
				working: false
			}
		},
		methods: {
			openCamera() {
				this.$refs['camera-input'].click()
			},

			async onCameraPicked(evt) {
				const files = Array.from(evt.target.files || [])
				// Permet de reprendre deux fois la même photo d'affilée, le champ gardant sinon sa valeur
				evt.target.value = null

				if(files.length === 0) {
					return
				}

				await this.emitFiles(this.multiple ? files : files[0])
				this.$emit('change', evt)
			},

			onFilePicked(files) {
				return this.emitFiles(files)
			},

			/* Les photos de 12 Mpx dépassent la limite d'upload, on les allège avant de les remonter */
			async emitFiles(files) {
				this.working = true

				try {
					this.$emit('input', await Common.compressImageFiles(files))
				}
				finally {
					this.working = false
				}
			}
		},
		computed: {
			showCamera() {
				return Common.isTouchDevice()
			}
		}
	}
</script>
